export const TL_RECON_LOADING = 'TL_RECON_LOADING'
export const TL_RECON_REPORT_LOADED = 'TL_RECON_REPORT_LOADED'
export const TL_RECON_REPORT_FAILED = 'TL_RECON_REPORT_FAILED'
export const TL_RECON_EXECUTING = 'TL_RECON_EXECUTING'
export const TL_RECON_EXECUTED = 'TL_RECON_EXECUTED'
export const TL_RECON_EXECUTE_FAILED = 'TL_RECON_EXECUTE_FAILED'
export const TL_RECON_ROW_UPDATING = 'TL_RECON_ROW_UPDATING'
export const TL_RECON_ROW_UPDATED = 'TL_RECON_ROW_UPDATED'
export const TL_RECON_ROW_UPDATE_FAILED = 'TL_RECON_ROW_UPDATE_FAILED'
export const TL_RECON_ROW_APPROVED = 'TL_RECON_ROW_APPROVED'
export const TL_RECON_ROW_RESOLVED = 'TL_RECON_ROW_RESOLVED'
export const TL_RECON_MAPPINGS_LOADED = 'TL_RECON_MAPPINGS_LOADED'
export const TL_RECON_MAPPINGS_FAILED = 'TL_RECON_MAPPINGS_FAILED'
export const TL_RECON_COMPANIES_LOADED = 'TL_RECON_COMPANIES_LOADED'
export const TL_RECON_COMPANIES_FAILED = 'TL_RECON_COMPANIES_FAILED'
export const TL_RECON_UNMAPPED_ORGS_LOADED = 'TL_RECON_UNMAPPED_ORGS_LOADED'
export const TL_RECON_UNMAPPED_ORGS_FAILED = 'TL_RECON_UNMAPPED_ORGS_FAILED'
